<template>
  <v-container fluid fill-height align-start ma-0 pa-2>
    <v-row no-gutters>
      <i-page-title title="fileUpload" />
      <v-col cols="12" sm="12" lg="12" class="pa-2">
        <i-card-vertical headerTitle="파일업로드3" :useBtnList="buttonUseList" @btnSearch="btnSearch()">
          <template v-slot:body>
            <v-layout column layout-col-height0 overflow-auto>
              <v-col cols="12" md="12" class="row pa-0">
                <v-col cols="12" class="mt-2">
                  <DxDataGrid
                    id="targetDataGrid"
                    class="layout-col-height1-body"
                    :ref="dxDataGridRef"
                    :data-source="targetList"
                    :remote-operations="false"
                    :hover-state-enabled="true"
                    :allow-column-reordering="true"
                    :allow-column-resizing="true"
                    :row-alternation-enabled="true"
                    :column-auto-width="true"
                    :show-borders="true"
                    :show-row-lines="true"
                    :selection="{ mode: 'single' }"
                    key-expr="targetId"
                    :focused-row-enabled="true"
                    @focused-row-changed="onFocusedRowChanged"
                  >
                    <DxColumn data-field="targetId" data-type="string" width="300px" alignment="center" caption="고객 번호" />

                    <DxColumn data-field="targetType" data-type="string" width="300px" alignment="center" caption="고객 이름" />
                  </DxDataGrid>
                </v-col>
              </v-col>

              <div>
                <div class="widget-container">
                  <DxFileUploader
                    id="uploaderContainer"
                    :ref="dxFileUploader"
                    accept="*"
                    :multiple="true"
                    upload-mode="useButtons"
                    upload-url="/api/file/imUpload?desc="
                    :upload-custom-data="uploadermultiData"
                    :max-file-size="maxFileSize"
                    selectButtonText="Select File"
                    labelText=""
                    @uploaded="onUploaded"
                    @upload-error="onUploadError"
                    @startedUpload="onStartedUpload"
                    @value-changed="onValueChanged"
                    @upload-aborted="onUploadAborted"
                  />
                </div>
                <span class="note"> Maximum file size: <span>1 GB</span>. </span>
              </div>
              <span>파일리스트</span>
              <v-col cols="12" md="12" class="row pa-0">
                <v-col cols="12" class="mt-3">
                  <v-row class="fileList" v-for="(file, index) in files" :key="index">
                    <svg-icon icon-class="upload"></svg-icon>
                    <v-col>
                      <span class="fileNm"> File Name: {{ file.fileNm }} </span><br />
                      <span class="mt-0 fileSize">File size: {{ file.fileSize }}</span>
                    </v-col>
                    <v-btn class="mt-3" elevation="0" color="btn_sub" dark x-small @click="fileDownload(file)">
                      <!-- <svg-icon icon-class="download"></svg-icon> -->
                      다운로드
                    </v-btn>
                    <v-btn class="mt-3 rounded-0" icon large @click="fileRemove(file)">
                      <svg-icon icon-class="close"></svg-icon>
                    </v-btn>
                  </v-row>
                </v-col>
              </v-col>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { DxDataGrid, DxColumn } from 'devextreme-vue/data-grid'
import iPageTitle from '@/components/common/iPageTitle.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import { DxFileUploader } from 'devextreme-vue/file-uploader'
import { getFile, getFileList, deleteFile, downloadFile, getTargetList } from '@/api/baseManage/fileUpload'
import notify from 'devextreme/ui/notify'

export default {
  name: 'groupManage',
  components: {
    DxDataGrid,
    DxColumn,
    DxFileUploader,
    'i-page-title': iPageTitle,
    'i-card-vertical': iCardVertical
  },
  data() {
    return {
      maxFileSize: 1073741824,
      dxDataGridRef: 'targetDataGrid',
      dxFileUploader: 'uploaderContainer',
      allowedFileExtensions: ['.jpg', '.jpeg', '.gif', '.png'],
      fileData: [],
      uploadermultiData: {},
      files: [],
      allMode: 'allPages',
      buttonUseList: [
        'btnSearch' //조회
      ],
      targetList: [],
      searchParams: {}
    }
  },
  computed: {
    gridData: function() {
      return this.$refs[this.dxDataGridRef].instance
    },
    fileUploader: function() {
      return this.$refs[this.dxFileUploader].instance
    }
  },
  beforeMount() {
    getTargetList().then(res => {
      this.targetList = []
      this.targetList = res.list
    })
  },
  methods: {
    ///////////////////////////////////////
    /*       File Uploader Event        */
    ///////////////////////////////////////
    onUploaded(e) {
      e.component._files.forEach((element, index) => {
        if (element._isLoaded) {
          this.fileUploader.removeFile(index)
        }
      })
      notify(this.$t('파일이 업로드 되었습니다.'), 'success', 300)
    },
    onUploadError(e) {
      e.component._files.forEach((element, index) => {
        if (element._isError) {
          this.fileUploader.removeFile(index)
          notify(this.$t('파일을 업로드 할 수 없습니다.'), 'error', 300)
        }
      })
    },
    onStartedUpload() {},
    onValueChanged(e) {
      this.fileUploader.repaint()
      e.component._files.forEach((element, index) => {
        if (element.value.name.length > 200) {
          e.component._uploadButton._$element.remove()
          element.uploadButton._$element.remove()
          element.$statusMessage[0].firstChild.nodeValue = 'File Name is too long'
          element.$file[0].className += ' dx-fileuploader-invalid'
        }
      })

      console.log('onValueChanged', e)
    },
    onUploadAborted(e) {
      console.log('eeee: ' + e)
    },
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    btnSearch() {
      getFileList()
        .then(res => {
          console.log(res)
          if (res.success) {
            this.removeFocus()
            this.files = []
            this.files = res.list
          }
        })
        .catch(error => {
          console.log(error)
          if (error.response.data.code == null) {
            this.$vToastify.error({ body: this.$t('errorToastMsg') + ': ' + this.$t('errorToastServerClose') })
          } else {
            console.log(error)
            this.$vToastify.error({
              body:
                this.$t('errorToastID') +
                ': ' +
                this.$t(error.response.data.code) +
                '<br>' +
                this.$t('errorToastMsg') +
                ': ' +
                this.$t(error.response.data.msg)
            })
          }
        })
        .finally(() => {})
    },
    fileRemove(file) {
      this.$vToastify
        .prompt({
          body: '파일을 삭제하시겠습니까?',
          answers: { Yes: true, No: false }
        })
        .then(value => {
          if (!value) return
          else {
            deleteFile(file)
              .then(res => {
                if (res.success) {
                  this.btnSearch()
                  notify(this.$t('파일이 삭제되었습니다.'), 'success', 300)
                }
              })
              .catch(error => {
                if (error.response.data.code == null) {
                  this.$vToastify.error({ body: this.$t('errorToastMsg') + ': ' + this.$t('errorToastServerClose') })
                } else {
                  console.log(error)
                  this.$vToastify.error({
                    body:
                      this.$t('errorToastID') +
                      ': ' +
                      this.$t(error.response.data.code) +
                      '<br>' +
                      this.$t('errorToastMsg') +
                      ': ' +
                      this.$t(error.response.data.msg)
                  })
                }
              })
              .finally(() => {})
          }
        })
    },
    fileSearch() {
      getFile(this.searchParams)
        .then(res => {
          console.log(res)
          if (res.success) {
            this.files = []
            this.files = res.list
          }
        })
        .catch(error => {
          console.log(error)
          if (error.response.data.code == null) {
            this.$vToastify.error({ body: this.$t('errorToastMsg') + ': ' + this.$t('errorToastServerClose') })
          } else {
            console.log(error)
            this.$vToastify.error({
              body:
                this.$t('errorToastID') +
                ': ' +
                this.$t(error.response.data.code) +
                '<br>' +
                this.$t('errorToastMsg') +
                ': ' +
                this.$t(error.response.data.msg)
            })
          }
        })
        .finally(() => {})
    },
    fileDownload(file) {
      console.log(file.fileId)
      downloadFile(file.fileId).then(res => {
        if (res.success) console.log(res)
      })
    },
    ///////////////////////////////////////
    /*           DataGrid Event          */
    ///////////////////////////////////////
    onFocusedRowChanged(e) {
      if (e.rowIndex < 0) return
      this.uploadermultiData = { targetType: e.row.data.targetType, targetId: e.row.data.targetId }

      this.searchParams = {
        targetType: e.row.data.targetType,
        targetId: e.row.data.targetId,
        fileId: 0
      }

      getFile(this.searchParams)
        .then(res => {
          console.log(res)
          if (res.success) {
            this.files = []
            this.files = res.list
          }
        })
        .catch(error => {
          console.log(error)
          if (error.response.data.code == null) {
            this.$vToastify.error({ body: this.$t('errorToastMsg') + ': ' + this.$t('errorToastServerClose') })
          } else {
            console.log(error)
            this.$vToastify.error({
              body:
                this.$t('errorToastID') +
                ': ' +
                this.$t(error.response.data.code) +
                '<br>' +
                this.$t('errorToastMsg') +
                ': ' +
                this.$t(error.response.data.msg)
            })
          }
        })
        .finally(() => {})
    },
    removeFocus() {
      this.uploadermultiData = { targetType: '', targetId: '' }
      this.gridData.clearSelection()
      this.gridData.option('focusedRowIndex', -1)
    },
    gridInit() {
      this.gridData.clearSelection()
    }
  }
}
</script>

<style>
.widget-container {
  margin-right: 320px;
}

.contents h4 {
  margin-bottom: 10px;
  font-weight: 500;
  font-size: 18px;
}

.contents {
  margin-top: 50px;
  margin-left: 10px;
  display: none;
}

.fileList {
  padding: 10px;
  width: 400px;
  background-color: rgba(183, 183, 183, 0.1);
}

.fileNm {
  height: 20px;
  font-weight: bold;
}

.fileList > .fileSize {
  height: 20px;
  font-size: 12px;
}
</style>
